import axios from 'axios'
import { ActionListPayload } from '@/types/action'

export default async function changeStarWorks({
  id,
  ...payload
}: ActionListPayload) {
  await axios.put(`/api/v1/star-work/${id}`, payload)
}
